import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export default {
  name: 'UPPER',
  category: FunctionCategory.TEXT,
  shortDescription: 'Converts text to uppercase.',
  description: 'Converts all lowercase letters in a text string to uppercase.',
  params: [
    {
      name: 'text',
      type: ArgType.any,
      description: 'The text to convert to uppercase.',
      // Custom coercion to ensure any type can be input and converted to string
      // This matches Excel and Google Sheets behavior which converts numbers, dates,
      // booleans, etc. to strings before applying uppercase
      coerce: (typedValue: TypedValue, context?): string =>
        formatTypedValue(typedValue, {}, '', undefined, context),
    },
  ],
  // NOTE: Google Sheets & Excel behavior is locale-sensitive and this is locale-insensitive
  // We're OK with this as a product tradeoff for now since we don't have much localization support today
  // In the future when we do have localization support, this should change to something like `text.toLocaleUpperCase()`
  eval: (text: string): string => text.toUpperCase(),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
